module.exports = __webpack_public_path__ + "static/media/health3.1d177b0e.png";